export const MENU_SUPPORT_MESSAGE_MAX = 5000
